export enum HierarchyTreeItemType {
    DIAGRAM = "DIAGRAM",
    ELEMENT = "ELEMENT",
    FOLDER = "FOLDER",
    SUBTREE = "SUBTREE",
}
